export const SidebarType = {
    default: "default",
    bsp: "bsp"
}

export type SidebarType = typeof SidebarType[keyof typeof SidebarType]